import { render, staticRenderFns } from "./hdpItemMMOX.vue?vue&type=template&id=0846dff0&lang=pug&"
import script from "./hdpItemMMOX.vue?vue&type=script&lang=js&"
export * from "./hdpItemMMOX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports